import { render, staticRenderFns } from "./AdminShopProfitReport.vue?vue&type=template&id=2be16fd0&scoped=true"
import script from "./AdminShopProfitReport.vue?vue&type=script&lang=js"
export * from "./AdminShopProfitReport.vue?vue&type=script&lang=js"
import style0 from "./AdminShopProfitReport.vue?vue&type=style&index=0&id=2be16fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be16fd0",
  null
  
)

export default component.exports